import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { type AuthState, type CompanyState, createAuthState, createCompanyState } from './slices'

export type StoreState = AuthState & CompanyState

export const useBoundStore = create<StoreState>()(
	persist(
		(...a) => ({
			...createAuthState(...a),
			...createCompanyState(...a),
		}),
		{
			name: 'avansuite-store',
			partialize: (state) => ({
				token: state.token,
				user: state.user,
			}),
		}
	)
)
